import 'assets/css/accueil.css';
import 'assets/css/HAGD-Custom.css';

import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useState} from 'react';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DNS from '../components/DNS/dns.js';
import axios from '../components/Axios/Axios.js';

import 'assets/scss/card-reponsive.scss';

// react-bootstrap components
import {
  Row,
} from 'react-bootstrap';
import Content from 'react-bootstrap-sweetalert/dist/components/Content';
import NotificationAlert from 'react-notification-alert';
import {useTranslation} from 'react-i18next';
import {translations} from '../i18n/translations';


const Home = (props) => {
  const User = useSelector((state) => state.user);

  const {t} = useTranslation();
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [showRdv, setRdv] = useState();
  const [showReservations, setReservations] = useState();
  const [showConciergerie, setConciergerie] = useState();
  const [showEvent, setEvent] = useState();
  const [showEventSport, setEventSport] = useState();
  const [showBeautyRoom, setBeautyRoom] = useState();
  const [showCyd, setCyd] = useState();
  const [showFoodles, setFoodles] = useState();
  const [showWorklib, setWorklib] = useState();
  const [showOneflex, setOneflex] = useState();
  const [showFrichti, setFrichti] = useState();
  const [showEconic, setEconic] = useState();
  const [showNouvelatrium, setNouvelatrium] = useState();
  const [showLeCointre, setLeCointre] = useState();
  const [showLogo, setLogo] = useState();
  useEffect(() => {
    getArea();
    getBuildings();
  }, []);

  const getArea = () => {
    const requestOptionsAxiosHeaders = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token ' + token['tokenRedux'],
      },
    };
    axios
        .get(
            DNS + '/area/crudArea/' +
            currentBuilding['currentbuildingRedux'].pk +
            '/',
            requestOptionsAxiosHeaders,
        )
        .then((response) => {
          setRdv(response.data.fields[0].liste_de_rdv);
          setReservations(response.data.fields[0].réservation);
          setConciergerie(response.data.fields[0].conciergerie);
          setEvent(response.data.fields[0].évènement);
          setEventSport(response.data.fields[0].salle_de_sport);
          setBeautyRoom(response.data.fields[0].beautyRoom);
          setCyd(response.data.fields[0].cyd);
          setFoodles(response.data.fields[0].foodles);
          setWorklib(response.data.fields[0].worklib);
          setOneflex(response.data.fields[0].oneFlex);
          setFrichti(response.data.fields[0].frichti);
          setEconic(response.data.fields[0].econic);
          setNouvelatrium(response.data.fields[0].nouvelatrium);
          setLeCointre(response.data.fields[0].lecointre);
        });
  };

  const getBuildings = () => {
    axios
        .get(DNS + '/building/crudBuilding/')
        .then((response) => {
          response.data.fields.map((building, key) => {
            if (currentBuilding['currentbuildingRedux'].pk == building.pk) {
              console.log(building.logo);
              setLogo(building.logo);
            }
          });
        });
  };

  useEffect(() => {
    // console.log('32blanche: ', currentBuilding)
    const modify = props.location.search;
    console.log('modify', modify);
    if (modify) {
      notify('tc');
    }
  }, []);

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>Votre modification a bien été prise en compte.</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const content = (
    <>
      <div className={'d-lg-none d-md-none d-sm-none mt-2'}>
        <h5 style={{color: 'white', lineHeight: '1', fontFamily: 'CeraPro'}}>
          {'Bonjour  ' +
            User['user']['firstName'] +
            ' ' +
            ' et bienvenue sur votre plateforme de services'}
        </h5>
      </div>

      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef}/>
      </div>

      {showRdv == true ? (

            <Link to="/resident/table" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"
              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0">
                      <a className="title-yellow" href="#">
                        {t(translations.APPOINTMENT_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle" style={{color: 'white'}} href="#">
                        {t(translations.APPOINTMENT_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
        ) : null}
      {showReservations == true ? (
            <Link to="/resident/Reservations" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"
              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow" href="#">
                        {t(translations.MEETING_BLOCK_TITLE)}
                      </a><br/>
                      {
                      User['user'].role == 'superCollab' ?
                      <a className="subtitle" href="#">
                        {t(translations.MEETING_SUBTITLE)}
                      </a> :
                      <a className="subtitle" href="#">
                        {t(translations.MEETING_SUBTITLE2)}
                      </a>
                      }
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
        ) : null}
      {showConciergerie == true ? (
            <Link to="/resident/Conciergerie" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"
              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow" href="#">
                        {t(translations.CONCIERGE_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle" href="#">
                        {t(translations.CONCIERGE_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
        ) : null}
      {showEvent == true ? (
            <Link to="/resident/Events" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"
              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow" href="#">
                        {t(translations.EVENT_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle" href="#">
                        {t(translations.EVENT_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
      ) : null}
      {showEventSport == true ? (
            <Link to="/resident/EventSport" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"
              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow" href="#">
                        {/* Mes Plis et Colis*/}
                        {t(translations.GYM__BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle" href="#">
                        {/* Consulter mes plis et colis*/}
                        {t(translations.GYM__SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Link>
        ) : null}
      { showBeautyRoom == true ?
            <Link to="/resident/EventBeautyRoom" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.BEAUTY_ROOM_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.BEAUTY_ROOM_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </Link> :
        null
      }
      { showCyd == true ?
            <a href={currentBuilding.currentbuildingRedux.name == 'Ilo' ? 'https://ilo.conqueryourday.app' : currentBuilding.currentbuildingRedux.name == 'BIRD' ? 'https://bird.conqueryourday.app' : currentBuilding.currentbuildingRedux.name == '32 BLANCHE' ? 'https://32blanche.conqueryourday.app/' : 'https://helloworld.conqueryourday.app'} target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.CYD_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.CYD_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showFoodles == true ?
            <a href="https://app.foodles.co/signin-or-signup" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.FOODLES_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.FOODLES_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showWorklib == true ?
            <a href="https://app.worklib.io/" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.WORKLIB_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.WORKLIB_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showOneflex == true ?
            <a href="https://cnes.oneflex.fr/" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.ONEFLEX_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.ONEFLEX_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showFrichti == true ?
            <a href="https://www.frichti.co/onboarding-cantine/5a846839-be95-41f2-b968-a07349cf86f1" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.RESTAURATION_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.RESTAURATION_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showEconic == true ?
            <a href="https://econic.conqueryourday.app/" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.CYD_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.CYD_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showNouvelatrium == true ?
            <a href="https://m.nouvelatrium.net/" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.ATRIUM_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.ATRIUM_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }
      { showLeCointre == true ?
            <a href="https://32blanche.lecointreparis.com/" target="_blank" rel="noopener noreferrer" className="col-sm-12 col-12 col-md-6 col-lg-6 pl-0 pr-0">
              <div
                className="card mb-0 rounded-0"

              >
                <div className="card-img-overlay d-flex flex-column">
                  <div className="card-body py-0 px-0 align-items-center d-flex justify-content-center">
                    <h4 className="card-title mt-0 ">
                      <a className="title-yellow">
                        {t(translations.LECOINTRE_BLOCK_TITLE)}
                      </a><br/>
                      <a className="subtitle">
                        {t(translations.LECOINTRE_SUBTITLE)}
                      </a>
                    </h4>
                  </div>
                </div>
              </div>
            </a> :
        null
      }

    </>
  );
  return (
    <Content className={'content d-flex align-items-center p-0'}>
      <Row className="ml-0 mr-0 pr-0 pl-0">
        <div id="bloc-accueil-gauche" className="row ml-0 mr-0 pr-0 pl-0">
          {content}
        </div>
        <div id="bloc-accueil-droit" className="row ml-0 mr-0 pr-0 pl-0"
          style={{
            width: '33%',
            backgroundImage: 'url(' + showLogo + ')',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'}}>
        </div>
      </Row>

    </Content>

  );
};

export default Home;
